import React from 'react';
import {Button, Flex, Form, Input} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import IntlMessage, {IntlMessageText} from "../../../../../../components/IntlMessage/IntlMessage";
import MyText from "../../../../../../components/UI/Text/MyText";
import classes from "../../../Applications/application.module.css";

const {TextArea} = Input;

const Step4Competences = ({currentStep}) => {
    const {t} = useTranslation();

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={"small"}>
            <Form.Item
                rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microQ.descOfCompetenceAndOutcomes') + " " + t('inRu')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="opDescOfCandORu"
            >
                <TextArea
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "microQ.descOfCompetenceAndOutcomes"})}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microQ.descOfCompetenceAndOutcomes') + " " + t('inKz')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="opDescOfCandOKz"
            >
                <TextArea
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "microQ.descOfCompetenceAndOutcomes"})}
                />
            </Form.Item>

            <Form.Item
                rules={[{required: true, message: <IntlMessage id={'requiredField'}/>}]}
                label={t('microQ.descOfCompetenceAndOutcomes') + " " + t('inEng')}
                labelCol={{span: 24}}
                className={classes.formInput}
                style={{width: '100%', padding: 0}}
                name="opDescOfCandOEng"
            >
                <TextArea
                    rootClassName={classes.formInput}
                    placeholder={IntlMessageText.getText({id: "microQ.descOfCompetenceAndOutcomes"})}
                />
            </Form.Item>

            <Form.List name="opCompetences" rules={[{required: true, message: t('requiredField')}]}>
                {(fields, {add, remove}) => (
                    <Flex vertical gap={10}>
                        <IntlMessage id={"microQ.competences"}/>
                        {fields.map(({key, name, ...restField}, index) => (
                            <Flex
                                key={key}
                                gap={"small"}
                                justify={"flex-start"}
                                align={"baseline"}
                                vertical
                                style={{
                                    padding: 8,
                                    border: '1px solid white',
                                    borderRadius: 8,
                                    backgroundColor: "white"
                                }}
                            >
                                <MyText size={"small"} medium uppercase>
                                    <IntlMessage id={"listOfCompetenciesShort"}/> {index + 1}
                                </MyText>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameRu']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameRu')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameKz']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameKz')}/>
                                </Form.Item>
                                <Form.Item
                                    {...restField}
                                    name={[name, 'nameEng']}
                                    className={classes.formInputBlock}
                                    rules={[{required: true, message: t('requiredField')}]}
                                >
                                    <Input placeholder={t('nameEng')}/>
                                </Form.Item>
                                <MinusCircleOutlined onClick={() => remove(name)}/>
                            </Flex>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                                <IntlMessage id={"certificate.addField"}/>
                            </Button>
                        </Form.Item>
                    </Flex>
                )}
            </Form.List>
        </Flex>
    );
};

export default Step4Competences;
